<template>
  <div
    v-if="visible"
    :class="['flash-message', status]"
    :style="positionStyle"
  >
    {{ message }}
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";

export default {
  setup() {
    const visible = ref(false);
    const message = ref("");
    const status = ref("");

    // Compute the position style based on screen size
    const positionStyle = computed(() => {
      if (window.innerWidth >= 768) {
        return {
          bottom: "20px",
          right: "20px",
        };
      } else {
        return {
          bottom: "20px",
          left: "20px",
          right: "20px",
          width: "calc(100% - 40px)", // Take full width minus padding
        };
      }
    });

    // Function to show the flash message
    const showFlashMessage = (newStatus, newMessage) => {
      status.value = newStatus;
      message.value = newMessage;
      visible.value = true;

      // Automatically hide the message after 3 seconds
      setTimeout(() => {
        visible.value = false;
      }, 3000);
    };

    // Expose the showFlashMessage function to the parent component
    return {
      visible,
      message,
      status,
      positionStyle,
      showFlashMessage,
    };
  },
};
</script>

<style scoped>
.flash-message {
  position: fixed;
  padding: 15px 20px;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  z-index: 1000;
  animation: slideIn 0.5s ease-out, bounce 0.5s ease-out 0.5s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px; /* Limit width on larger screens */
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .flash-message {
    font-size: 14px; /* Smaller font size for mobile */
    padding: 12px 16px; /* Smaller padding for mobile */
    border-radius: 6px; /* Slightly smaller border radius */
  }
}

.success {
  background-color: #4caf50;
}

.failure {
  background-color: #f44336;
}

.warning {
  background-color: #ff9800;
}

/* Slide-in animation */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Bounce animation */
@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>